// @lumi/app-kit shared i18n vocabulary (ADR 0026 §7) — locale es.
// Byte-identical common.*/errors.* used across >=3 apps + owned by app-kit components.
// Apps merge appKitMessages under their own catalog; the no-shadow check forbids an
// app from redefining these keys. Generated from the per-app catalogs.
export default {
  // The sidebar's account menu + history buttons (suite design foundation, spec §4):
  // byte-identical across every chrome, so owned here rather than by nine app catalogs.
  accountMenu: {
    profile: 'Mi perfil',
    settings: 'Configuración',
    theme: 'Apariencia',
    themeLight: 'Claro',
    themeDark: 'Oscuro',
    support: 'Soporte',
    back: 'Atrás',
    forward: 'Adelante',
    collapseSidebar: 'Contraer la barra lateral',
    expandSidebar: 'Expandir la barra lateral',
    // The account row of a phone-only account (issue 698): no name, no address.
    signedIn: 'Sesión iniciada',
  },
  // A sidebar entry another of the viewer's own roles opens (#1028): the
  // greyed entry's hint, its switch dialog, and the role list joiner.
  roleLock: {
    hint: 'Solo como {roles}. Cambiar de rol: abajo a la izquierda, tu cuenta → Rol.',
    body: 'Tienes esta área como {roles}. Ahora mismo trabajas como {active}.',
    action: 'Abrir como {role}',
    where: 'Puedes cambiar de rol en cualquier momento: abajo a la izquierda, tu cuenta → Rol.',
    listOr: '{list} o {last}',
  },
  common: {
    // Every DateField's calendar and typing hint (issue 823; People's own until then).
    datePicker: {
      open: 'Abrir calendario',
      previousMonth: 'Mes anterior',
      nextMonth: 'Mes siguiente',
      month: 'Mes',
      year: 'Año',
      clear: 'Borrar la fecha',
      dayToken: 'DD',
      monthToken: 'MM',
      yearToken: 'AAAA',
    },
    deactivate: 'Desactivar',
    revoke: 'Revocar',
    remove: 'Quitar',
    actions: 'Acciones',
    calendar: 'Calendario',
    cancel: 'Cancelar',
    close: 'Cerrar',
    confirmTitle: 'Confirmar',
    contactSupport: 'Contactar con soporte',
    copyLink: 'Copiar enlace',
    edit: 'Editar',
    language: 'Idioma',
    linkCopied: 'Enlace copiado',
    linkCopyFailed: 'No se pudo copiar el enlace',
    moduleListHeading: 'Tus módulos',
    moduleTeaserAction: 'Añadir en facturación',
    moduleTeaserHeading: 'También en lumi',
    moduleTeaserNote: 'El propietario del workspace, los administradores y los Billing Managers pueden añadir estos módulos.',
    moduleTeaserTag: 'No incluido en tu plan',
    no: 'No',
    nothingHere: 'Aquí todavía no hay nada',
    ok: 'OK',
    refresh: 'Actualizar',
    retry: 'Reintentar',
    role: 'Rol',
    save: 'Guardar',
    search: 'Buscar',
    switchModule: 'Cambiar de módulo',
    tabsNext: 'Mostrar las pestañas siguientes',
    tabsPrevious: 'Mostrar las pestañas anteriores',
    understood: 'Entendido',
    userDeactivated: '{name} (cuenta desactivada)',
    yes: 'Sí',
  },
  errors: {
    // ADR 0036 code-first branch (errorKeyFor): a backend `code` wins over the
    // status. `invalid_credentials` is what every login door answers a bad
    // sign-in with — a bare 401 would otherwise fall through to
    // `errors.unauthorized`, telling someone who mistyped their password that
    // their session expired (issue 364, F10). It never lets a caller tell an
    // unknown account apart from a mistyped password — the two answer
    // identically — so the copy names both fields.
    // `MASTER_INVITE_REJECTED` is people-api's fallback when the identity
    // service refuses an invitation payload without a code of its own (issue
    // 364, decisions round 1): without an entry here it degrades to the
    // status-derived message, which says nothing about what to look at. Its
    // sibling `MASTER_TENANT_NOT_FOUND` stays local to PersonDetailView on
    // purpose — that one names a next step specific to that screen.
    codes: {
      invalid_credentials: 'Error al iniciar sesión. Comprueba tu dirección de correo electrónico y tu contraseña.',
      MASTER_INVITE_REJECTED: 'Esta invitación se ha rechazado porque no se han podido aceptar los datos de la persona. Comprueba la dirección de correo electrónico y el nombre en la ficha de la persona y vuelve a intentarlo.',
      PERSON_EMAIL_INVALID: 'Esta persona no tiene una dirección de correo electrónico válida, por lo que no se puede invitar ningún acceso. Corrige primero la dirección en la ficha de la persona.',
      PERSON_PHONE_INVALID: 'Este número de móvil no es válido. Introdúcelo en formato internacional, con + y el prefijo del país, p. ej. +34 612 345 678.',
      PERSON_ACCESS_PHONE_TAKEN: 'Otra persona ya tiene un acceso con este número de móvil o lo está recibiendo. Un número, una persona.',
      PHONE_ACCESS_UNAVAILABLE: 'El acceso por número de móvil no está disponible aquí, ni para este espacio de trabajo ni para el país de este número. Usa una dirección de correo.',
      SUITE_ROLE_NEEDS_EMAIL: 'Esta persona inicia sesión con un número de móvil y no tiene dirección de correo. Los roles de suite reciben correos legales, de facturación y de consentimiento, así que necesitan una dirección.',
      OWNER_NEEDS_EMAIL: 'Esta persona inicia sesión con un número de móvil y no tiene dirección de correo. La persona propietaria recibe correos legales y contractuales, así que la propiedad necesita una dirección.',
      RECORD_CHANGED: 'Otra persona ha cambiado este registro mientras lo editabas. Recárgalo: tu entrada se conserva como borrador.',
    },
    appUpdatedBody: 'Esta página no se pudo cargar por completo porque la aplicación se actualizó. Recarga para continuar.',
    appUpdatedTitle: 'Hay una nueva versión disponible',
    conflict: 'Esta acción entra en conflicto con el estado actual. Recarga e inténtalo de nuevo.',
    contactSupport: 'Contactar con soporte',
    exhausted: 'Esto parece estar realmente roto. Lo sentimos. Ponte en contacto con soporte.',
    failedTitle: 'Acción fallida',
    forbidden: 'No tienes permiso para esta acción.',
    loadFailedTitle: 'No se ha podido cargar',
    network: 'Sin conexión con el servidor. Comprueba tu conexión a Internet.',
    notFound: 'No se encontró el elemento solicitado.',
    rateLimited: 'Demasiadas solicitudes. Espera un momento e inténtalo de nuevo.',
    recordChangedReload: 'Otra persona guardó este registro después de que lo abrieras, así que tu cambio no se aplicó. Recarga para ver la versión actual: tu entrada se conserva y se puede restaurar.',
    refreshFailedTitle: 'Es posible que esto no esté actualizado',
    server: 'Se produjo un error en el servidor. Inténtalo más tarde.',
    timeout: 'El servidor no respondió a tiempo. Inténtalo de nuevo en un momento.',
    unauthorized: 'Tu sesión ha caducado. Inicia sesión de nuevo.',
    unexpected: 'Se produjo un error al mostrar esto. Inténtalo de nuevo.',
    validation: 'Revisa los datos introducidos.',
  },
  notReady: {
    title: 'Esto todavía no está listo para ti',
    body: 'Tu espacio de trabajo aún se está preparando. Te llevaremos de vuelta al workspace en 5 segundos.',
  },
  // The workspace this app was opened on does not exist, or can no longer be
  // reached (issue 364, F57). ONE message for BOTH causes on purpose: ats-api
  // answers a suspended tenant and an unknown slug identically, and splitting
  // the copy would confirm which workspaces exist. `body` therefore names no
  // cause, and nothing on the page names a workspace, a slug or a person.
  tenantUnavailable: {
    title: 'Este espacio de trabajo no está disponible',
    body: 'Este espacio de trabajo no existe o no se puede acceder a él en este momento: comprueba la dirección que has abierto.',
    accountLead: 'Tus propios datos y tus facturas siguen disponibles en tu cuenta de lumi.',
    accountCta: 'Ir a tu cuenta de lumi',
    supportLead: 'Si esto es un error, escríbenos y lo resolvemos contigo.',
    // The signed-in person's own membership is gone (issue 669): a revoked demo guest,
    // or a demo that ended under an open tab.
    ended: {
      title: 'No tienes acceso a este espacio de trabajo',
      body: 'Has iniciado sesión, pero no eres (o ya no eres) miembro de este espacio de trabajo. Si eras invitado a una demo, la demo ha terminado o se ha retirado tu invitación.',
      accountLead: 'Tu propia cuenta de lumi no se ve afectada.',
    },
  },
  billing: {
    banner: {
      suspendedTitle: 'Espacio bloqueado',
      suspendedMessage: 'Este espacio de trabajo está suspendido. Contacta con nosotros para restablecer el acceso.',
      lockedBody: 'Este espacio de trabajo se ha bloqueado por un problema de facturación pendiente. El acceso a todos los módulos está pausado por ahora.',
      lockedSupportLead: 'Para restablecer el acceso, contacta con nuestro equipo de soporte:',
      lockedSupportCta: 'Contactar con soporte',
      lockoutOn: 'De lo contrario, se bloqueará el {date}.',
      fixCardTitle: 'Actualiza tu tarjeta',
      fixCardBody: 'Tu último pago fue rechazado porque no se aceptó tu tarjeta.',
      fixCardCta: 'Actualizar tarjeta',
      softDeclineTitle: 'Asegura tu pago',
      softDeclineBody: 'No pudimos cobrar tu último pago y lo reintentaremos automáticamente. Asegúrate de que tu método de pago tenga saldo suficiente.',
      softDeclineCta: 'Revisar método de pago',
      scaTitle: 'Confirma tu pago',
      scaBody: 'Tu banco necesita que confirmes este pago antes de que podamos cobrarlo.',
      scaCta: 'Confirmar pago',
      recoveryError: 'No se pudo iniciar el pago ahora mismo. Inténtalo de nuevo en un momento.',
      chargebackTitle: 'Salda tu pago revertido',
      chargebackBody: 'Tu banco revirtió un pago, así que vuelve a estar pendiente. Añade un método de pago para saldarlo.',
      chargebackCta: 'Añadir método de pago',
      trialTitle: 'Añade un método de pago',
      trialBody: 'Tu prueba ha finalizado. Añade un método de pago para mantener activo este espacio de trabajo.',
      trialCta: 'Añadir método de pago',
      reviewTitle: 'Revisa tu facturación',
      reviewBody: 'Este espacio de trabajo necesita una acción de facturación para seguir activo.',
      reviewCta: 'Gestionar facturación',
      contactTitle: 'Contacta con tu administrador',
      contactBody: 'Hay un problema de facturación que requiere atención para mantener activo este espacio de trabajo.',
    },
  },
  legalNoticeBanner: {
    title: 'Los avisos legales necesitan tu atención',
    employeeBody: 'Las invitaciones están en pausa hasta que el aviso de privacidad para empleados esté completo.',
    candidateBody: 'El portal de empleo está fuera de línea hasta que los avisos para candidatos estén completos.',
    imprintBody: 'El portal de empleo está fuera de línea hasta que se guarde un aviso legal.',
    candidateImprintBody: 'El portal de empleo está fuera de línea hasta que los avisos para candidatos estén completos y se guarde un aviso legal.',
    cta: 'Abrir Avisos legales',
  },
  // The one "needs you" strip (issue 713): the list label, the hide control and the
  // per-item sentences. A lone legal item reuses legalNoticeBanner.* word for word.
  needsYou: {
    label: 'Aún te necesita:',
    hide: 'Ocultar',
    timeRules: {
      link: 'Reglas de jornada laboral',
      cta: 'Revisar',
      body: 'Las reglas de jornada laboral aún no se han revisado. lumi calcula con las reglas legales por defecto y solo avisa hasta que alguien confirme que encajan con vuestra empresa.',
    },
    legal: { link: 'Completar los avisos legales' },
    billing: {
      link: 'Completar la facturación',
      cta: 'Abrir facturación',
      bodyBoth: 'Añade tus datos de facturación y un método de pago para que tu espacio de trabajo siga funcionando sin interrupciones.',
      bodyInvoiceDetails: 'Añade tus datos de facturación para que tus facturas se emitan correctamente.',
      bodyPaymentMethod: 'Añade un método de pago para que tu espacio de trabajo siga funcionando sin interrupciones.',
    },
  },
  // Consented temporary support access (ADR 0041): the marker every module
  // chrome shows beside the tenant name while a supporter is inside a grant.
  supportAccess: {
    label: 'Acceso de soporte',
    until: 'Acceso de soporte temporal hasta {until}: todo lo que haga aquí queda registrado en el registro de auditoría de este tenant.',
  },
  // Idle session timeout (issue 265). Owned by app-kit's IdleLogoutGuard, except
  // idleSignedOut — the login pages (workspace, system-admin) render that after
  // the bounce, and it is the same suite-wide policy statement, so it stays in one
  // place rather than drifting between the two login surfaces.
  session: {
    idleTitle: '¿Sigues ahí?',
    idleBody: 'Llevas un rato sin actividad. Por tu seguridad, cerraremos tu sesión automáticamente.',
    idleStay: 'Mantener la sesión',
    idleSignedOut: 'Tu sesión se cerró tras {minutes} minutos de inactividad. Vuelve a iniciar sesión.',
  },
  // Browser form drafts (owner-stamped, 7 days, typed values only — app-kit
  // utils/formDraftStorage.ts). Owned by app-kit's DraftBanner and by the
  // sign-out warning every module chrome shows, so the wording lives here instead
  // of drifting across five app catalogs.
  formDrafts: {
    bannerTitle: 'Borrador sin guardar',
    bannerSavedAt: 'Guardado en este dispositivo: {when}',
    bannerRecordChanged: 'El registro ha cambiado desde este borrador. Restaurar solo recupera los campos que cambiaste.',
    restore: 'Restaurar',
    discard: 'Descartar',
    closeTitle: '¿Descartar los datos introducidos en «{form}»?',
    closeBody: 'Se perderán los datos no guardados.',
    closeConfirm: 'Descartar',
    closeCancel: 'Seguir editando',
    recordChangedTitle: 'Cambiado por otra persona',
    reload: 'Recargar',
    forms: {
      'apprentice': {
        planStation: 'Estación del plan de formación',
        skillCatalogue: 'Catálogo de competencias',
        trainingData: 'Datos de la formación',
      },
      'ats': {
        workflowEditor: 'Editor de flujo de trabajo',
      },
      'backoffice': {
        applicationForm: 'Solicitud',
        createApplication: 'Nueva solicitud',
        customField: 'Campo personalizado',
        customFields: 'Campos personalizados',
        emailSettings: 'Configuración de correo',
        jobAd: 'Oferta de empleo',
        jobAdTemplate: 'Plantilla de oferta de empleo',
        jobEdit: 'Puesto',
        portalSettings: 'Configuración del portal de empleo',
        ravenBatchPublish: 'Publicación de empleos en lote',
        ravenPublish: 'Publicación de empleo',
        role: 'Rol',
        suggestion: 'Sugerencia',
        supportTicket: 'Ticket de soporte',
        supportTicketReply: 'Respuesta al ticket de soporte',
        talentEdit: 'Perfil de talento',
        workflowAction: 'Acción de flujo de trabajo',
        workflowCondition: 'Condición de flujo de trabajo',
        workflowGuard: 'Guardia de flujo de trabajo',
        workflowState: 'Estado de flujo de trabajo',
        workflowTransition: 'Transición de flujo de trabajo',
      },
      'people': {
        bankAccount: 'Cuenta bancaria',
        companyProfile: 'Perfil de la empresa',
        employmentContract: 'Contrato de trabajo',
        myProfile: 'Mi perfil',
        onboardingTemplate: 'Plantilla de onboarding',
        oneTimePayment: 'Pago único',
        orgUnit: 'Unidad organizativa',
        person: 'Persona',
        taxProfile: 'Perfil fiscal',
        wageAssignment: 'Embargo salarial',
      },
      'system-admin': {
        fileQuota: 'Cuota de archivos',
        skillDetail: 'Detalle de la competencia',
        suggestionNotes: 'Notas de la sugerencia',
      },
      'time': {
        blueprint: 'Modelo de jornada laboral',
        leaveRequest: 'Solicitud de ausencia',
        leaveType: 'Tipo de ausencia',
        orgGroup: 'Grupo organizativo',
        project: 'Proyecto',
        role: 'Rol',
        userProfile: 'Perfil de usuario',
        weekGrid: 'Tabla semanal',
        workTimeModel: 'Modelo de tiempo de trabajo',
      },
      'user': {
        ssoSettings: 'Configuración de SSO',
      },
      'workspace': {
        billingProfile: 'Perfil de facturación',
        wizardGeneral: 'Asistente de configuración',
      },
    },
  },
  // Suite-wide legal footer (issue 221): the § 5 DDG imprint and the privacy
  // notice of the Lumi entity live once on the marketing site, and every app
  // links to them through the shared LegalLinksFooter. The wording is
  // byte-identical everywhere, so it belongs to app-kit rather than to any app.
  legal: {
    imprint: 'Aviso legal',
    privacy: 'Privacidad',
    terms: 'Términos y condiciones',
    label: 'Información legal',
    employeeNotice: 'Privacidad en {company}',
  },
  dataImport: {
    run: {
      stepsLabel: 'Pasos de la importación',
      steps: {
        file: 'Archivo',
        questions: 'Preguntas',
        review: 'Revisar',
        commit: 'Confirmar',
      },
      toOverview: 'Volver al resumen',
      reading: 'Leyendo {file}',
      checking: 'Comprobando las filas',
      committing: 'Importando los datos',
      tables: '{count} tabla | {count} tablas',
      rows: '{count} fila | {count} filas',
      aiOn: 'Lumi mejora la asignación',
      aiOff: 'Asignación por reglas',
      proposalByRules: 'Propuesta por reglas · {reason}',
      reasons: {
        off: 'Lumi estaba desactivado para este archivo.',
        disabled: 'La IA está desactivada en este espacio de trabajo.',
        quota: 'La cuota de IA estaba agotada.',
        no_key: 'No hay ninguna clave de IA configurada.',
        error: 'No se pudo contactar con Lumi en este momento.',
      },
    },
    title: 'Importación de datos',
    intro: 'Importa datos existentes de un sistema antiguo: sube un archivo, revisa la asignación de campos, examina la prueba y luego confirma.',
    backToList: 'Volver al resumen',
    sourceSystem: 'Sistema de origen',
    cancelled: 'Esta importación se canceló.',
    steps: {
      upload: 'Subida',
      analysis: 'Análisis',
      mapping: 'Asignación',
      dryRun: 'Prueba',
      commit: 'Confirmación',
    },
    status: {
      uploaded: 'Subido',
      analyzing: 'Analizando',
      mapping_ready: 'Revisar asignación',
      dry_running: 'Prueba en curso',
      dry_run_ready: 'Prueba lista',
      committing: 'Confirmando',
      completed: 'Completado',
      failed: 'Fallido',
      cancelled: 'Cancelado',
    },
    formats: {
      csv: 'CSV',
      xlsx: 'Excel',
      json: 'JSON',
      sql_dump: 'Volcado SQL',
      hropen: 'HR Open JSON',
    },
    transforms: {
      none: 'Directo',
      date: 'Fecha',
      number: 'Número',
      boolean: 'Sí/No',
      enum_map: 'Asignación de valores',
      split_name: 'Dividir nombre',
      concat: 'Concatenar',
      const: 'Constante',
      skip: 'Ignorar',
    },
    upload: {
      sourceSystem: 'Nombre del sistema de origen',
      sourceSystemHint: 'Se guarda como referencia para que reimportar el mismo archivo actualice registros en lugar de duplicarlos.',
      sourceSystemPlaceholder: 'p. ej. rrhh_antiguo',
      sourceSystemFirst: 'Primero indica el sistema de origen.',
      dropHint: 'Arrastra un archivo aquí o selecciónalo',
      formats: 'CSV, Excel (XLSX), JSON o volcado SQL — máx. 50 MB',
      browse: 'Elegir archivo',
      uploading: 'Subiendo …',
    },
    running: {
      uploaded: 'Iniciando análisis …',
      analyzing: 'Analizando archivo …',
      dry_running: 'Prueba en curso …',
      committing: 'Escribiendo datos …',
      hint: 'Los archivos grandes pueden tardar unos minutos. Esta página se actualiza sola.',
    },
    failed: {
      title: 'La importación falló',
      generic: 'No se pudo leer el archivo.',
      unsupported: 'Este formato de archivo no es compatible. Usa CSV, Excel, JSON, un volcado SQL o HR Open.',
      empty: 'El archivo no contiene ninguna fila.',
      enqueue: 'No se pudo iniciar la importación. Inténtalo de nuevo en un momento.',
      dryRun: 'No se pudieron comprobar las filas. Vuelve a empezar con el archivo desde el resumen.',
      commit: 'No se pudieron incorporar los datos. Vuelve a empezar con el archivo desde el resumen.',
    },
    questions: {
      quoted: '«{value}»',
      saving: 'Se está guardando la asignación',
      companionRunning: '{entity} se están creando en {module}',
      reading: {
        title: 'Lo que hemos reconocido',
        taken: 'Se importará',
        notTaken: 'No se importará',
        from: 'de la columna',
        nothingTaken: 'De este archivo todavía no se importa nada.',
        split: '(dividido)',
        joined: '(combinado)',
        reasons: {
          other_entry: 'pertenece a otra entrada',
          never_importable: 'nunca se importa',
          no_field: 'ningún campo adecuado',
        },
        wrong: '¿Algo no cuadra?',
        editMapping: 'Cambiar la asignación al detalle',
        improve: 'Que Lumi lo mejore',
        improveConflict: 'El archivo no se puede volver a leer ahora mismo. Recarga la página e inténtalo de nuevo.',
      },
      extras: {
        title: 'El archivo contiene también otros datos. ¿Quieres importarlos también?',
        columns: 'De {columns}.',
        companion: 'De {columns}: {count} valor nuevo, que se crea en {module} antes que el resto de los datos. | De {columns}: {count} valores nuevos, que se crean en {module} antes que el resto de los datos.',
        companionTruncated: 'De {columns}: al menos {count} valor nuevo, que se crea en {module} antes que el resto de los datos. | De {columns}: al menos {count} valores nuevos, que se crean en {module} antes que el resto de los datos.',
        asOwnEntry: 'Lo que se importa además aparece en la migración como una entrada propia (de {file}).',
        forbidden: 'No tienes permiso en {module} para esto. La importación continúa sin estos datos.',
        unavailable: '{module} no ha respondido ahora mismo. La importación continúa sin estos datos.',
      },
      list: {
        heading: 'No tenemos nada más que preguntarte | Tenemos una cosa que preguntarte | Tenemos {count} cosas que preguntarte',
      },
      uncertain: {
        title: 'La columna {column} contiene {samples}: ¿es {field}?',
        titleNoSamples: 'La columna {column}: ¿es {field}?',
        yes: 'Sí, es {field}',
        no: 'No, es …',
        pickField: 'Elegir un campo',
        skip: 'No importar',
      },
      required: {
        title: 'Para {entity} necesitamos {field}. ¿De dónde sale?',
        forAll: 'Igual para todos:',
        pickValue: 'Elegir un valor',
        inColumn: 'Está en la columna …',
        pickColumn: 'Elegir una columna',
        none: 'El archivo no lo tiene',
      },
      supervisor: {
        title: '¿Quién es el responsable de estas personas?',
        fromColumn: 'De la columna',
        columnHint: 'El número de empleado tiene que aparecer en este archivo o existir ya en Personal.',
        onePerson: 'Una persona para todos:',
        pickPerson: 'Elegir una persona',
        noPersons: 'No puedes elegir una persona para todos: la lista de personas no está disponible para ti aquí.',
        self: 'Por ahora cada persona se dirige a sí misma',
        selfHint: 'El organigrama lo construyes después en Personal.',
        deferred: 'Por ahora sin responsable',
        deferredHint: 'Al revisar, marcamos las filas sin responsable.',
        personsTruncated: 'Las primeras 500 personas por nombre; el número de empleado de la persona que buscas también puedes indicarlo mediante una columna.',
      },
      enum: {
        title: '{column} contiene valores que {module} no conoce',
        count: '{count}×',
        pick: 'Elige una opción',
        leaveEmpty: 'dejar vacío',
        rowLabel: 'Asignación para {value}',
        viaCompanion: 'se crea en {module}',
      },
      date: {
        title: '¿Cómo está escrita la fecha en {column}?',
        day: 'día',
        month: 'mes',
        year: 'año',
        yearShort: 'año (2 cifras)',
        example: '{sample} se lee como {date}',
      },
      fold: {
        title: 'Todas las asignaciones al detalle ({count} columna) | Todas las asignaciones al detalle ({count} columnas)',
        show: 'Mostrar',
        hide: 'Ocultar',
      },
      verdict: {
        title: 'Este archivo no puede convertirse en {entry}',
        missing: 'Falta: {fields}. Ninguna columna del archivo puede aportarlo.',
        extraHint: 'Si desmarcas arriba los datos adicionales, esto deja de aplicarse.',
        elsewhere: 'Elegir otra entrada:',
        readAs: 'Leer como {entry}',
        otherModule: 'Si el archivo pertenece a otro módulo, descártalo aquí y súbelo allí, donde corresponde.',
        discard: 'Descartar archivo',
      },
      footer: {
        next: 'A continuación revisamos cada fila. Todavía no se guarda nada.',
        nextCreating: 'Primero creamos {count} valor nuevo ({what}) en {module} y después revisamos cada fila de tu archivo. | Primero creamos {count} valores nuevos ({what}) en {module} y después revisamos cada fila de tu archivo.',
        back: 'Atrás',
        confirm: 'Siguiente: revisar los datos',
        confirmCreating: 'Siguiente: crear y revisar',
        open: 'Queda una pregunta abierta | Quedan {count} preguntas abiertas',
        withoutThem: 'Puedes continuar sin estos datos.',
      },
    },
    mapping: {
      hint: 'Revisa la asignación propuesta: un destino por tabla y un campo por columna. Las filas resaltadas son propuestas inciertas.',
      targetEntity: 'Destino',
      skipTable: 'No importar',
      skippedTable: 'Esta tabla no se importará.',
      ignoreColumn: 'Ignorar',
      sourceColumn: 'Columna',
      sample: 'Valores de ejemplo',
      targetField: 'Campo destino',
      transform: 'Transformación',
      preview: 'Vista previa',
      rowCount: '{count} filas',
      patternHint: 'Patrón de fecha, p. ej. DD.MM.YYYY',
      multiTargetHint: 'Destino {index} de {total} — el mismo archivo alimenta varios destinos',
      valueMap: 'Asignar valores',
      valueMapHint: 'Asigna los valores de origen a los valores permitidos en el sistema. Los valores sin asignar producen un error por fila en la prueba. Se basa en hasta 20 valores de ejemplo distintos de la columna.',
      valueMapUnmapped: '— sin asignar —',
      addColumnRow: 'Asignar una columna de nuevo',
      customFieldBadge: 'Campo personalizado',
      createCustomField: 'Crear un campo personalizado…',
      confirm: 'Confirmar asignación e iniciar prueba',
    },
    report: {
      dryRunHint: 'Prueba — aún no se ha escrito nada. Revisa los totales y errores antes de confirmar.',
      completedHint: 'Importación completada. Los datos se han escrito.',
      created: 'Creados',
      updated: 'Actualizados',
      skipped: 'Omitidos',
      errors: 'Errores',
      errorList: '{count} errores',
      downloadErrors: 'Descargar todos los errores',
      row: 'Fila',
      errorMessage: 'Mensaje',
      backToMapping: 'Volver a la asignación',
      commit: 'Confirmar datos',
      commitConfirmTitle: '¿Confirmar datos?',
      commitConfirmBody: 'La importación escribirá ahora en este módulo. Se crean registros nuevos y se actualizan los existentes. No se puede deshacer automáticamente.',
      commitStarted: 'Confirmación iniciada: los datos se están escribiendo.',
    },
    review: {
      title: 'Esto es lo que entra en el sistema. ¿Quieres cambiar algo?',
      filterLabel: 'Filtrar filas',
      note: 'Los cambios solo valen para esta importación. Tu archivo se queda como está.',
      row: 'Fila',
      status: 'Estado',
      choose: 'Elegir …',
      yes: 'Sí',
      no: 'No',
      noRows: 'No hay filas para esta selección.',
      rowsNoun: 'Filas',
      tiles: {
        new: 'Nuevo',
        updated: 'Actualizado',
        toClear: 'Por aclarar',
        newNote: '{things} se crearán',
        updatedNote: 'ya existen, se completan los campos que faltan',
        toClearNote: 'si no, se quedan fuera',
      },
      leftOut: '{count} fila omitida | {count} filas omitidas',
      filter: {
        all: 'Todas',
        skipped: 'Omitidas',
      },
      statuses: {
        new: 'nuevo',
        updated: 'actualizado',
        open: 'abierto',
        corrected: 'corregido',
        skipped: 'omitido',
      },
      fixField: 'Corregir {field} en la fila {row}',
      reasonOf: 'Por qué la fila {row} está abierta',
      popoverLabel: 'Fila {row}: qué falla',
      mean: '¿Quisiste decir {value}?',
      accept: 'Usar {value}',
      findPerson: 'Buscar una persona …',
      pickPerson: 'Elegir una persona',
      setForAll: 'Aplicar a las {count} iguales',
      skipRow: 'Omitir esta fila',
      leaveEmpty: 'Dejar este campo vacío en esta fila',
      undo: 'Deshacer',
      reason: {
        required: 'Falta {field}',
        missing: 'Falta un valor obligatorio',
        invalid: 'El valor no encaja',
        notFound: '{ref} no encontrado',
        notFoundAny: 'Referencia no encontrada',
        ambiguous: 'Referencia poco clara',
        emailLinked: 'Este correo pertenece a un acceso',
        general: 'Fila no importada',
        skipped: 'Fila omitida',
      },
      changes: '{count} cambio guardado | {count} cambios guardados',
      openRows: '{count} fila por aclarar | {count} filas por aclarar',
      footer: {
        unchecked: '{changes} · {open}. Primero comprueba de nuevo, luego importa.',
        withdrawn: 'Todos los cambios están deshechos. Primero comprueba de nuevo, luego importa.',
        checked: '{open}. También puedes importar ahora; esta fila se queda fuera. | {open}. También puedes importar ahora; estas {count} se quedan fuera.',
        clear: 'Todo aclarado.',
      },
      back: 'Volver a las preguntas',
      recheck: 'Comprobar de nuevo',
      commit: 'Importar {count} {things}',
      truncated: {
        all: 'Se muestran {shown} de {total} filas; están todas las {open} por aclarar.',
        some: 'Se muestran {shown} de {open} filas por aclarar; las demás están en el archivo de errores.',
      },
      notice: {
        movedOn: 'Entretanto la importación ha avanzado. La página muestra ahora cómo está.',
        cell: 'Esta celda no se puede cambiar aquí.',
        value: 'El valor no encaja.',
        generic: 'No se pudo guardar el cambio.',
        notChecked: 'Hay cambios que la comprobación aún no ha visto. Comprueba de nuevo y luego importa.',
      },
      commitConfirmOpen: '{count} fila se queda fuera y se listará después. | {count} filas se quedan fuera y se listarán después.',
    },
    // An import report's error row, worded from the facts the module sent (rowErrorText.ts).
    rowErrors: {
      required: '{field} está vacío, pero cada fila necesita un valor.',
      unknownField: '{field} no se puede importar aquí.',
      invalidEnum: '«{value}» no es un valor válido para {field}. Valores válidos: {allowed}.',
      // With the review\'s handles: the cell holds the way out.
      invalidEnumCell: '«{value}» no es un valor válido para {field}. Valores válidos: {allowed}. Elige un valor permitido en la celda.',
      unresolved: {
        person: 'No se encontró ninguna persona cuyo {keys} sea «{value}».',
        supervisor: 'No se encontró ningún responsable jerárquico cuyo {keys} sea «{value}».',
        functionalSupervisor: 'No se encontró ningún responsable funcional cuyo {keys} sea «{value}».',
        orgUnit: 'No se encontró ninguna unidad org. cuyo {keys} sea «{value}».',
        parentOrgUnit: 'No se encontró ninguna unidad org. superior cuyo {keys} sea «{value}».',
      },
      supervisorRequired: 'No se encontró ningún responsable jerárquico cuyo {keys} sea «{value}», y esta persona aún no tiene ninguno. Toda persona activa necesita uno: importa primero al responsable jerárquico o indica uno que ya exista.',
      unknownEntity: 'Este tipo de datos no se puede importar aquí.',
      emailLinked: 'Esta persona inicia sesión en lumi con esta dirección de correo, así que la importación no la cambia. La dirección sigue como está en el acceso: deja el campo vacío en esta fila para importar el resto.',
      supervisorMissing: 'Toda persona activa necesita un responsable jerárquico y esta persona no tiene ninguno. Indica uno en el archivo o crea primero al responsable.',
      transformFailed: 'No se pudo convertir «{value}» en la columna {field}. Revisa su formato en «Transformación» en el paso de asignación.',
      transformFailedNoValue: 'No se pudo convertir un valor de la columna {field}. Revisa su formato en «Transformación» en el paso de asignación.',
      unknown: 'Esta fila no se importó. Los detalles están en el archivo de errores.',
      skippedByUser: 'Omitiste esta fila, así que no se importa.',
      requiredAny: 'En esta fila falta un valor obligatorio.',
      invalidEnumAny: 'Un valor de esta fila no es uno de los valores permitidos.',
      unknownFieldAny: 'Un campo de esta fila no se puede importar aquí.',
      unresolvedAny: 'No se encontró aquello a lo que remite esta fila. Créalo primero u omite la fila.',
      unresolvedLocal: '{thing}: «{value}» no se encontró. Crea la entrada primero u omite la fila.',
      unresolvedUser: 'Ninguna persona de este espacio coincide con esta fila.',
      invalidTime: 'Las horas de esta fila no encajan entre sí.',
      invalidState: 'El estado de esta fila no existe en el flujo publicado.',
      stateChanged: 'El flujo cambió mientras se importaba esta fila. Comprueba de nuevo.',
      invalidCustomValue: 'El valor de un campo personalizado de esta fila no encaja.',
      ambiguous: {
        collision: '{ref}: «{value}» coincide con dos registros distintos: con uno como ID externo y con otro como {other}. La importación no adivina: elige abajo el registro correcto.',
        otherSystem: '{ref}: «{value}» no es un ID externo de este sistema de origen, sino de «{system}», y además coincide con un registro como {other}. La importación no adivina: importa con el sistema de origen «{system}» si se trata del mismo, o elige abajo el registro correcto.',
        holderHasExternalId: '{ref}: «{value}» solo coincide como {other}, y ese registro ya tiene el ID externo «{otherId}» en este sistema de origen. La importación no adivina: elige abajo «{otherId}» si es el que buscas.',
      },
      // Without the review's handles (the completed report lists the row; nothing here can be chosen).
      ambiguousPlain: {
        collision: '{ref}: «{value}» coincide con dos registros distintos: con uno como ID externo y con otro como {other}. La importación no adivina: haz que la referencia sea inequívoca en el archivo.',
        otherSystem: '{ref}: «{value}» no es un ID externo de este sistema de origen, sino de «{system}», y además coincide con un registro como {other}. La importación no adivina: importa con el sistema de origen «{system}» si se trata del mismo, o haz que la referencia sea inequívoca.',
        holderHasExternalId: '{ref}: «{value}» solo coincide como {other}, y ese registro ya tiene el ID externo «{otherId}» en este sistema de origen. La importación no adivina: usa «{otherId}» si es el que buscas.',
      },
      localRefs: {
        department: 'Departamento',
        location: 'Ubicación',
        candidate: 'Candidato',
        job: 'Puesto',
        client: 'Cliente',
        project: 'Proyecto',
        bookingType: 'Tipo de registro',
        leaveType: 'Tipo de ausencia',
      },
      refs: {
        person: 'Persona',
        supervisor: 'Responsable jerárquico',
        functionalSupervisor: 'Responsable funcional',
        orgUnit: 'Unidad org.',
        parentOrgUnit: 'Unidad org. superior',
      },
      supervisorInactive: {
        supervisor: 'El responsable jerárquico indicado ya no está activo y por eso no puede dirigir a nadie.',
        functional: 'El responsable funcional indicado ya no está activo y por eso no puede dirigir a nadie.',
      },
      supervisorUnconfirmed: {
        supervisor: 'RR. HH. aún no ha confirmado al responsable jerárquico indicado, por eso no puede dirigir a nadie. Confírmalo primero en People.',
        functional: 'RR. HH. aún no ha confirmado al responsable funcional indicado, por eso no puede dirigir a nadie. Confírmalo primero en People.',
      },
      datesInverted: 'La fecha de {end} es anterior a la de {start}.',
      agreementCodeInvalid: '{field} solo admite letras, dígitos, «-», «_» y «.», como máximo 60 caracteres y sin espacios.',
      statusTransition: 'Un contrato no puede pasar de «{from}» a «{to}».',
      reportingCycle: 'Esta asignación cerraría la línea jerárquica en un círculo.',
      ambiguousOrgCode: 'Varias unidades org. de distinto tipo tienen el código «{value}». Indica la correcta por su ID externo.',
      keys: {
        externalId: 'ID externo',
        employeeNumber: 'número de empleado',
        code: 'código',
      },
    },
    list: {
      title: 'Importaciones anteriores',
      file: 'Archivo',
      system: 'Sistema de origen',
      status: 'Estado',
      created: 'Creado',
      empty: 'Aún no hay importaciones.',
      open: 'Abrir',
      delete: 'Eliminar',
      deleteConfirmTitle: '¿Eliminar la importación?',
      deleteConfirmBody: '«{file}» y todos sus archivos de importación se eliminarán. Los datos ya incorporados se conservan.',
      deleted: 'Importación «{file}» eliminada.',
    },
  },
  dataExport: {
    title: 'Exportación HR Open',
    intro: 'Exporta los datos de este módulo como HR Open 4.5 (HR-JSON), validado contra el estándar.',
    create: 'Crear exportación',
    creating: 'Creando …',
    download: 'Descargar',
    password: {
      title: 'Contraseña del ZIP — visible solo ahora',
      hint: 'La exportación se crea como ZIP protegido con contraseña (AES-256) porque contiene datos personales. Copia la contraseña ahora — no se mostrará de nuevo. Abrir con p. ej. 7-Zip, WinZip o Keka.',
      copy: 'Copiar contraseña',
      copied: 'Copiada',
    },
    empty: 'Aún no hay exportaciones.',
    columns: {
      standard: 'Estándar',
      status: 'Estado',
      items: 'Registros',
      created: 'Creado',
    },
    status: {
      queued: 'En cola',
      generating: 'Generando',
      completed: 'Completado',
      failed: 'Fallido',
    },
  },
  // The demo's module picker (ADR 0083): the fork offers it on entry, the bar's
  // reset confirmation again. A locked module is booked (or core) and always in.
  // RoleNameTranslations.vue (ADR 0086): a custom role's names in other
  // languages, or the notice a system role gets instead.
  roleNames: {
    translations: 'Traducciones',
    translationsHint: 'El nombre en otros idiomas. Los campos vacíos muestran el nombre de arriba.',
    systemHint: 'Rol del sistema: lumi lo nombra en cada idioma. Su nombre y su descripción no se pueden cambiar; sus permisos sí.',
  },
  demoModules: {
    legend: 'Módulos en la demo',
    booked: 'Contratado — siempre incluido',
  },
  demoStage: {
    label: 'Demo',
    viewingAs: 'Ver como',
    personaPlaceholder: 'Elegir un rol',
    persona: {
      team_lead: 'Jefe de equipo',
      employee: 'Empleado',
      hr_admin: 'Admin de RR. HH.',
      recruiter: 'Reclutador',
      ats_admin: 'Administrador de ATS',
      council_member: 'Miembro del comité de empresa',
      apprentice: 'Aprendiz',
      trainer: 'Formador',
    },
    personaDoes: {
      team_lead: 'Decide sobre solicitudes de ausencia y corrección, y valora candidaturas.',
      employee: 'Registra jornadas de trabajo, solicita ausencias y hace corregir registros.',
      hr_admin: 'Crea personas, proyectos y ofertas de empleo.',
      recruiter: 'Avanza candidaturas en la primera selección y programa entrevistas.',
      ats_admin: 'Decide sobre ausencias, valora candidaturas y crea ofertas de empleo.',
      council_member: 'Emite el voto del comité de empresa sobre ofertas y propuestas.',
      apprentice: 'Marca etapas del plan de formación y registra jornadas de trabajo.',
      trainer: 'Revisa los informes de los aprendices y programa sus exámenes.',
    },
    picker: {
      title: '¿Desde el punto de vista de quién quieres ver la demo?',
      subtitle: '{count} compañeros en {company}. Cada rol tiene sus propias tareas — tus marcas se guardan por rol.',
      taskCount: '{total} tarea | {total} tareas',
      current: 'Vista actual',
    },
    intro: {
      lead: 'es ficticia. Las personas que aparecen también son ficticias. Todo lo que hay bajo la barra pertenece a la demo — en ella asumes distintos roles. Tu cuenta real no se ve afectada.',
      bridgeBefore: 'Puedes terminar la demo cuando quieras. Todos los datos de abajo se eliminan entonces y puedes configurar ',
      bridgeAfter: ' para tu organización.',
      close: 'Cerrar',
    },
    reset: 'Restablecer la demo',
    guestMarker: 'Invitado',
    guestWelcome: {
      invitedBy: 'Un compañero de {workspace} te ha invitado a esta demo.',
      invitedAnon: 'Un compañero te ha invitado a esta demo.',
      body: '{company} es inventada y se comparte con todas las demás personas de esta demo. Puede que otros ya hayan probado cosas, así que puede verse a medio usar. «{reset}» da a todos un nuevo comienzo. Tu acceso termina cuando termina la demo. Las personas que aparecen también son ficticias.',
    },
    cancel: 'Cancelar',
    rebuildFailed: 'No se pudo reconstruir la demo. Inténtalo de nuevo.',
    resetConfirm: {
      title: '¿Restablecer la demo?',
      body: 'Todo lo que {company} contiene ahora se descarta — incluido lo que tú o tus compañeros hayáis introducido, y el avance de todos en los recorridos — y la demo se vuelve a crear desde cero. Todos en la demo empiezan de nuevo; los accesos no cambian.',
      cta: 'Restablecer la demo',
    },
    // The demo bar's "Invite a colleague" dialog (issue 669).
    guests: {
      entry: 'Invitar a un compañero',
      title: 'Invitar a un compañero',
      subtitle: 'Los compañeros que invites ven esta demo tal como está y pueden probarla por sí mismos.',
      close: 'Cerrar',
      loading: 'Cargando…',
      retry: 'Reintentar',
      emailLabel: 'Correo electrónico de trabajo',
      emailPlaceholder: "nombre{'@'}empresa.com",
      send: 'Enviar invitación',
      sendAgain: 'Enviar de nuevo',
      slotsLeft: '{count} plaza libre | {count} plazas libres',
      exhausted: 'Las {limit} plazas están ocupadas. Revoca una invitación abajo para invitar a otra persona.',
      invalid: 'Introduce una dirección de correo válida.',
      listTitle: 'En esta demo además de ti',
      used: '{used} de {limit} ocupadas',
      empty: 'Todavía no has invitado a nadie.',
      state: {
        invited: 'Invitado',
        joined: 'Se ha unido',
      },
      revoke: 'Revocar',
      revoking: 'Revocando…',
      revokeFor: 'Revocar el acceso de {email}',
      about: {
        title: 'Qué es un invitado',
        sees: 'Un invitado ve esta demo exactamente como está ahora, incluido todo lo que ya has probado. «{reset}» en la barra da a todos un nuevo comienzo.',
        resets: 'Un invitado también puede restablecer la demo, para todos los que participan.',
        limits: 'Un invitado nunca puede terminar la demo ni tocar tu espacio de trabajo real.',
        ends: 'Los invitados se eliminan cuando termina la demo.',
      },
      feedback: {
        sent: 'Invitación enviada a {email}.',
        resent: 'Invitación enviada de nuevo a {email}.',
        undelivered: 'No se pudo entregar el correo a {email}. {email} está en la lista y ocupa una plaza — envía la invitación de nuevo para reintentarlo.',
        revoked: 'Se revocó el acceso de {email}. La plaza vuelve a estar libre.',
        alreadyMember: '{email} ya tiene acceso a este workspace.',
        limit: 'Todas las plazas están ocupadas. Revoca una invitación para invitar a otra persona.',
        rateLimited: 'Demasiadas invitaciones hoy. Inténtalo de nuevo más tarde.',
        notLive: 'Las invitaciones solo funcionan mientras la demo está activa. Se está reconstruyendo o ha empezado la configuración — inténtalo de nuevo cuando la demo vuelva.',
        operator: 'Has iniciado sesión como operador del sistema. Los operadores no pueden invitar a compañeros a la demo de un cliente.',
        operatorNotMember: '{email} pertenece a una cuenta de operador de lumi, que no puede unirse a la demo de un cliente. Invita a otra dirección.',
        notAPerson: '{email} pertenece a una cuenta que no es una persona, por ejemplo una cuenta de servicio. Invita el correo de trabajo de un compañero.',
        forbidden: 'Solo la persona propietaria del workspace o un administrador de la suite puede invitar a compañeros.',
        noticeIncomplete: 'Las invitaciones están en pausa hasta que los avisos para empleados en Avisos legales estén completamente rellenados.',
        accountClosed: 'Esa cuenta se ha cerrado y no se puede invitar.',
        unavailable: 'Ahora mismo no se pueden contar las invitaciones. Inténtalo de nuevo en un momento.',
        revokeFailed: 'No se pudo revocar el acceso de {email}. Inténtalo de nuevo.',
        generic: 'Algo ha salido mal. Inténtalo de nuevo.',
      },
    },
    leave: 'Terminar la demo',
    continueSetup: 'Continuar la configuración',
    menu: 'Acciones de la demo',
    signOut: 'Cerrar sesión',
    logoutHint: 'Durante la demo, cierra sesión desde la puerta o el menú de la barra de demo.',
    journey: {
      title: 'El recorrido de {name}',
      count: '{done} de {total} hechas',
      refresh: 'Actualizar el recorrido',
      unknown: 'Algunas comprobaciones no están disponibles: se muestra el último estado conocido.',
      yay: 'Ese era todo el recorrido de {name}. ¡Bien hecho!',
      bridgeAdmin: 'Has completado todos los recorridos. Cuando quieras, termina la demo y configura tu propio espacio de trabajo.',
      bridgeUser: 'Has completado todos los recorridos. Un administrador puede terminar la demo y configurar vuestro espacio de trabajo.',
      blockedReset: 'Un reinicio lo recupera:',
      blocked: {
        gone: 'Lo que necesita esta tarea ya no existe.',
      },
      next: 'A continuación',
      nextCta: 'Abrir en {module}',
      footer: 'La demo marca lo que haces.',
    },
  },
  // The shared notifications popover (NotificationsPopover.vue). Its own namespace: the
  // apps' `notifications.*` keys (inbox page, preferences) are theirs and stay put.
  notificationsPopover: {
    title: 'Notificaciones',
    empty: 'Estás al día.',
    markAllRead: 'Marcar todas como leídas',
    markRead: 'Marcar como leída',
    markUnread: 'Marcar como no leída',
    loading: 'Cargando…',
    openTarget: 'Abrir el elemento vinculado',
    goToAll: 'Ir a las notificaciones',
  },
  // The shared place search (PlacePicker.vue). `noMatchAdd` is the wording for hosts whose
  // typed text IS the name (Enter adds it as typed); `noMatch` for hosts that keep it beside the field.
  placePicker: {
    placeholder: 'Busca una ciudad o un municipio …',
    keptHint: 'Se guarda tal como lo has escrito, sin localidad vinculada.',
    searching: 'Buscando …',
    typeMore: 'Escribe al menos {count} caracteres',
    noMatch: 'Sin coincidencias: tu texto se conserva',
    error: 'La búsqueda ha fallado',
    rateLimited: 'Demasiadas búsquedas: se reintentará enseguida',
    resultsAnnouncement: 'Sin resultados | 1 resultado | {count} resultados',
    clear: 'Quitar localidad',
    noMatchAdd: 'No se ha encontrado ninguna ciudad: pulsa Intro para añadir el nombre tal cual',
  },
  // The suite's five app names and their one-line launcher descriptions, in this
  // language. THE one copy: component-lib's registry carries no displayed string, and
  // every app merges this underneath its own messages (ADR 0026 section 7).
  lumiModules: {
    suite: {
      name: 'Inicio',
      description: 'Tu resumen del espacio de trabajo',
    },
    ats: {
      name: 'Reclutamiento',
      description: 'Vacantes, candidaturas y proceso de selección',
    },
    time: {
      name: 'Tiempo',
      description: 'Registro de tiempo, cuentas de horas de trabajo y aprobaciones',
    },
    people: {
      name: 'Personal',
      description: 'Fichas de personal, departamentos y sedes',
    },
    apprentice: {
      name: 'Aprendices',
      description: 'Cuadernos de formación digitales y planes de formación',
    },
  },
};
